import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'Michael T.',
    location: 'Miami, FL to Newport, RI',
    text: "LynJones Logistics made shipping my 32' Sea Ray completely stress-free. The driver was professional, kept me updated, and the boat arrived in perfect condition. Highly recommend their boat transport services."
  }, {
    name: 'Sarah Jenkins',
    location: 'San Diego, CA to Seattle, WA',
    text: 'I was nervous about yacht transport across the coast, but they handled everything flawlessly. No upfront payment gave me peace of mind, and the final price matched the quote exactly.'
  }, {
    name: 'David R.',
    location: 'Austin, TX to Charleston, SC',
    text: "Best boat movers I've ever used. Fast quote, clear communication, and they handled the oversized permits for my catamaran without a hitch. Will use them again."
  }];
  return <section className="py-20 bg-slate-50" data-id="element-301">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-302">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-303">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-304">
            Trusted by Boat Owners Nationwide
          </h2>
          <p className="text-lg text-slate-600" data-id="element-305">
            Don't just take our word for it. See what our customers say about
            our reliable boat shipping services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-306">
          {reviews.map((review, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 relative" data-id="element-307">
              <div className="flex gap-1 mb-4" data-id="element-308">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-309" />)}
              </div>
              <p className="text-slate-700 mb-6 italic leading-relaxed" data-id="element-310">
                "{review.text}"
              </p>
              <div data-id="element-311">
                <p className="font-bold text-brand-navy" data-id="element-312">{review.name}</p>
                <p className="text-sm text-slate-500" data-id="element-313">{review.location}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}